import { statusMeta } from '../../../shared/status/dictionary';
import { FilterBar, FilterChip, FilterMenu, FilterSearch } from '../../../shared/ui/filter-bar';
import type {
  IDestinationFilters,
  TDestinationHealthFilter,
  TDestinationUsedFilter,
} from '../../../entities/destination';

// The badge's own words, so the menu and the Status column never disagree.
const HEALTH: readonly TDestinationHealthFilter[] = [
  'healthy',
  'degraded',
  'failing',
  'idle',
  'disconnected',
  'not_counted',
  'unused',
];
const HEALTH_OPTIONS = HEALTH.map((value) => ({
  value,
  label: statusMeta('destination', value)?.label ?? value,
}));

const USED_OPTIONS: readonly { value: TDestinationUsedFilter; label: string }[] = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
];

interface IDestinationFiltersBarProps {
  filters: IDestinationFilters;
  onFilters: (next: IDestinationFilters) => void;
  /** Undefined while it cannot be exact: more than one page. */
  hasProblemsCount: number | undefined;
}

export const DestinationFiltersBar = ({
  filters,
  onFilters,
  hasProblemsCount,
}: IDestinationFiltersBarProps) => {
  // Any change of what is asked for starts back at the first page.
  const set = (patch: Partial<IDestinationFilters>) =>
    onFilters({ ...filters, ...patch, cursor: undefined });

  return (
    <FilterBar>
      <FilterMenu
        label="Health"
        value={filters.health}
        options={HEALTH_OPTIONS}
        onChange={(health) => set({ health })}
      />
      <FilterMenu
        label="Used in flows"
        value={filters.used}
        options={USED_OPTIONS}
        onChange={(used) => set({ used })}
      />
      <FilterChip
        on={filters.hasProblems}
        onClick={() => set({ hasProblems: !filters.hasProblems || undefined })}
        aria-pressed={Boolean(filters.hasProblems)}
      >
        Has problems{typeof hasProblemsCount === 'number' ? ` · ${hasProblemsCount}` : ''}
      </FilterChip>
      <FilterSearch
        placeholder="Find a destination"
        value={filters.q}
        onChange={(q) => set({ q })}
      />
    </FilterBar>
  );
};
